import axios from "axios";
import { User } from "../models";
import { UserDatabaseModel, userFromDatabaseModel } from "../database-models/user";

export function fetchUser(): Promise<User> {
    return axios.get('/1/user')
        .then(response => {
            if (!response.data.success || response.status !== 200) {
                throw 'Invalid user response'
            }
            return userFromDatabaseModel(response.data.result as UserDatabaseModel)
        })
}

export function fetchUsers(): Promise<User[]> {
    return axios.get('/1/admin/users', { })
        .then(response => {
            if (!response.data.success) {
                throw 'Failed to fetch user'
            }
            return (response.data.result as UserDatabaseModel[]).map(user => userFromDatabaseModel(user))
         })
}

export function deleteUser(id: string): Promise<void> {
    return axios.delete('/1/user/' + id)
        .then(response => {
            if (!response.data.success) {
                throw 'Failed to delete user'
            }
        })
}

export function impersonateUser(userId: string): Promise<void> {
    return axios.post('/1/admin/impersonate/' + encodeURIComponent(userId)).then(() => {});
}

export function stopImpersonating(): Promise<void> {
    return axios.post('/1/admin/impersonate/stop').then(() => {});
}